module.exports = __webpack_public_path__ + "img/unionpay@2x.fd5b4e80.png";